import React from 'react'
import styled from 'styled-components'
import gifCarouselSrc from '../../../images/grid-cc-final.mp4'
import { sectionMargin, sectionMobileMargin } from '../../constants'
import { mobile } from '../../utils/media-query'

const CarouselContainer = styled.div`
    margin-bottom: ${sectionMargin}px;
    video {
        width: 100%;
    }

    ${mobile.css`
        margin-bottom: ${sectionMobileMargin}px;
        overflow: hidden;
        width: 100%;

        video {
            width: unset;
            height: 430px;
        }
    `}
`

const GifCarousel = () => (
    <CarouselContainer>
        <video autoPlay loop muted playsInline>
            <source src={gifCarouselSrc} type="video/mp4" />
        </video>
    </CarouselContainer>
)

export default GifCarousel
